var map = {
	"./ar/asideHome/index.vue": [
		7044,
		7044
	],
	"./bn/asideHome/index.vue": [
		3674,
		3674
	],
	"./en/asideHome/index.vue": [
		2836,
		2836
	],
	"./fa/asideHome/index.vue": [
		7967,
		7967
	],
	"./ur/asideHome/index.vue": [
		3933,
		3933
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6964;
module.exports = webpackAsyncContext;